import React from "react";
import { Modal, Button, Image } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import styles from "./index.module.css";
import { fileUrl } from "../../components/config";

const ProductDetail = (props) => {
  const data = props.productDetail || {};
  return (
    <Modal
      open={true}
      width={800}
      onCancel={() => props.onCancel()}
      title="作品详情"
      footer={null}
    >
      <ul className={styles.productDetail}>
        <li>
          <p className={styles.label}>登记号：</p>
          <div>{data.registerCertNumber}</div>
        </li>
        <li>
          <p className={styles.label}>作品名称：</p>
          <div>{data.productName}</div>
        </li>
        <li>
          <p className={styles.label}>作品类别：</p>
          <div>{data.productCatName}</div>
        </li>
        {/* <li>
          <p className={styles.label}>作品文件：</p>
          <div>
            {data.productFile && JSON.parse(data.productFile).length > 0 ? (
              <Image.PreviewGroup>
                {JSON.parse(data.productFile).map((item, index) => {
                  return (
                    <Image
                      src={fileUrl+item.targetUrl}
                      key={index}
                      style={{
                        width: 40,
                        height: 36,
                        fontSize: 12,
                        padding: "0 1px",
                      }}
                    />
                  );
                })}
              </Image.PreviewGroup>
            ) : (
              "无展示图片"
            )}
          </div>
        </li> */}
        <li>
          <p className={styles.label}>展示图片：</p>
          <div>
            {data.productImage && JSON.parse(data.productImage).length > 0 ? (
              <Image.PreviewGroup>
                {JSON.parse(data.productImage).map((item, index) => {
                  return (
                    <Image
                      src={fileUrl + item.targetUrl}
                      key={index}
                      style={{
                        width: 40,
                        height: 36,
                        fontSize: 12,
                        padding: "0 1px",
                      }}
                    />
                  );
                })}
              </Image.PreviewGroup>
            ) : (
              "无展示图片"
            )}
          </div>
        </li>
        <li>
          <p className={styles.label}>著作权人：</p>
          <div>{data.copyrightsNames}</div>
        </li>
        {/* <li>
          <p className={styles.label}>创作性质：</p>
          <div>{data.productCreateNatName}</div>
        </li> */}
        <li>
          <p className={styles.label}>发表状态：</p>
          <div>{data.productPubStateName}</div>
        </li>
        <li>
          <p className={styles.label}>权利取得方式：</p>
          <div>{data.autAcpMethodName}</div>
        </li>
        <li>
          <p className={styles.label}>权利归属方式：</p>
          <div>{data.autBelMethodName}</div>
        </li>
        <li>
          <p className={styles.label}>创作意图说明：</p>
          <div style={{width:'80%'}}>{data.createIntention && data.createIntention!=="null"?data.createIntention:""}</div>
        </li>
        <li>
          <p className={styles.label}>作品独创性：</p>
          <div style={{width:'80%'}}>{data.createIntention &&data.productOriginal!=="null"?data.productOriginal:""}</div>
        </li>
        <li>
          <p className={styles.label}>登记证书：</p>
          <Button onClick={() => window.open(fileUrl+data.registerCertificateUrl)}>
            <FilePdfOutlined />
            查看证书
          </Button>
        </li>
      </ul>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "20px 0",
        }}
      >
        <Button onClick={() => props.onCancel()}>关闭</Button>
      </div>
    </Modal>
  );
};
export default ProductDetail;
